import { TableCell } from "pdfmake/interfaces";

/**
 * Defines a row in a table.
 */
export class Row {

    public cells: Array<TableCell> = [];
}
